import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { TimeconversionService } from '@fitness-force/api';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'time-formatted',
  templateUrl: './time-formatted.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class TimeFormattedComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  keyName!: string ;
  value!:number;
  format!:string;
  constructor(
    public timeService : TimeconversionService
  ) {}

  ngOnInit(): void {
  }

  getDate(date:any):Date{
    return this.timeService.ConvertUTCToLocalDateTime(date);
  }

}